<template>
  <header class="nav-header" :class="{ scrolled: isScrolled }">
    <div class="nav-bg-pattern"></div>
    <div class="container">
      <div class="logo">
        <router-link to="/">
          <img src="@/assets/jh-logo.png" alt="九火互娱" class="logo-image" />
        </router-link>
        <div class="nav-center">
          <div class="status-indicator">
            <span class="pulse"></span>
            <span class="status-text">技术服务中心</span>
          </div>
        </div>
      </div>

      <nav class="nav">
        <div class="nav-links">
          <router-link to="/" class="nav-link">
            <i class="fas fa-home"></i>
            <span>首页</span>
          </router-link>
          <router-link to="/about" class="nav-link">
            <i class="fas fa-users"></i>
            <span>关于我们</span>
          </router-link>
          <router-link to="/services" class="nav-link">
            <i class="fas fa-cogs"></i>
            <span>服务</span>
          </router-link>
          <router-link to="/contact" class="nav-link contact-link">
            <i class="fas fa-headset"></i>
            <span>联系我们</span>
          </router-link>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "NavHeader",
  data() {
    return {
      isScrolled: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
  },
};
</script>

<style scoped>
.nav-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 80px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.nav-bg-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.95),
      rgba(255, 255, 255, 0.85)
    ),
    url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23f5bb44' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.nav-header.scrolled {
  height: 70px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 40px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1;
}

.logo-image {
  height: 35px;
  width: auto;
  filter: drop-shadow(0 2px 8px rgba(245, 187, 68, 0.2));
  transition: all 0.3s ease;
  position: relative;
  top: 5px;
}
.logo {
  display: flex;
  align-items: center;
}
.logo .status-indicator {
  margin-left: 20px;
}
.logo:hover .logo-image {
  transform: scale(1.05);
  filter: drop-shadow(0 4px 12px rgba(245, 187, 68, 0.3));
}

.nav-center {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 20px;
  background: rgba(245, 187, 68, 0.05);
  border-radius: 20px;
  border: 1px solid rgba(245, 187, 68, 0.1);
}

.pulse {
  width: 8px;
  height: 8px;
  background: #4caf50;
  border-radius: 50%;
  position: relative;
}

.pulse::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: inherit;
  border-radius: inherit;
  animation: pulse 2s ease-out infinite;
}

.status-text {
  font-size: 14px;
  color: var(--text-primary);
  font-weight: 500;
}

.nav-links {
  display: flex;
  gap: 5px;
  background: rgba(255, 255, 255, 0.3);
  padding: 5px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.nav-link {
  text-decoration: none;
  color: var(--text-primary);
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-link i {
  font-size: 16px;
  color: #f5bb44;
  transition: all 0.3s ease;
}

.nav-link:hover {
  background: rgba(245, 187, 68, 0.1);
  transform: translateY(-1px);
}

.contact-link {
  background: linear-gradient(135deg, #f5bb44, #f4a834);
  color: white;
  margin-left: 5px;
}

.contact-link i {
  color: white;
}

.contact-link:hover {
  background: linear-gradient(135deg, #f4a834, #f5bb44);
  transform: translateY(-1px) scale(1.02);
  box-shadow: 0 4px 15px rgba(245, 187, 68, 0.2);
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  100% {
    transform: scale(2.5);
    opacity: 0;
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .container {
    padding: 0 20px;
  }

  .nav-center {
    display: none;
  }

  .nav-links {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    padding: 10px;
    border-radius: 25px;
  }

  .nav-link span {
    display: none;
  }

  .nav-link {
    padding: 12px;
  }

  .nav-link i {
    font-size: 18px;
  }

  .contact-link {
    margin-left: 0;
  }
}
</style>
